import { Accordion as BaseAccordion } from "@base-ui-components/react/accordion";
import { Children, ComponentProps, isValidElement } from "react";
import { accordionClasses } from "./Accordion.style";

type AccordionProps = ComponentProps<typeof BaseAccordion.Root> & {};

const Accordion = (props: AccordionProps) => {
  const { children, className, multiple = false, ...others } = props;
  Children.forEach(children, (child) => {
    // @ts-expect-error: TypeScript cannot infer the type of 'child' as a valid React element with a 'type' property, but we need to check for AccordionItem by its displayName.
    if (!isValidElement(child) && child.type?.displayName !== "AccordionItem") {
      console.error(
        "Accordion only accepts AccordionItem components as children."
      );
    }
  });

  return (
    <BaseAccordion.Root
      className={accordionClasses({
        className: typeof className === "string" ? className : "",
      })}
      multiple={multiple}
      {...others}
    >
      {children}
    </BaseAccordion.Root>
  );
};

export default Accordion;
